import React from 'react';
import { Button, Modal, ModalBody, ModalHeader} from 'reactstrap';
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";


const SubsSucess = (props) => {

    const history = useHistory();

    const handleClick = () => {
        history.push('/biddeasy-dashboard')
    }

    return (
        <Modal
            isOpen={props.showThankYou}
            toggle={props?.toggleThankYou}
            className='success-sub'
            // size='lg'
        >
            <ModalHeader className="succ-header" toggle={props?.toggleThankYou}></ModalHeader>
            <ModalBody className="succ-body">
                <div className='wrapper text-center'>
                    <div className='w-100'>
                        {props?.totalAmount > 1000000 ? 
                        <img className="ml-auto mr-auto succ-img" src={props?.email} alt='email'/> :
                        <img className="ml-auto mr-auto succ-img" src={process.env.REACT_APP_IMAGES_PATH + "subsSucess.webp"} alt='success'/>
                        }
                    </div>
                    { props?.totalAmount > 1000000 ?  
                    <p className="text-1">Your application has been
                     submitted</p>
                     :
                    <p className="text-1">Your IPO application has been
                        successfully submitted</p>
                        }
                   {props?.appNo &&  <p className="text-1">
                        Application Id : {props?.appNo}
                    </p>}
                    {props?.totalAmount < 1000000 && <p className="text-2 small-font">
                       {!props?.preBookText ? "Please accept your UPI mandate within 48 hours" 
                       : "Your bid will be placed when the IPO opens, and during market hours if the IPO is ongoing. You will receive an update on your registered email id."}
                        </p>}
                    {props?.totalAmount > 1000000 && 
                    <p className="text-1">
                    Kindly check your e-mail to understand the next step</p>
                    }
                    <Button onClick={handleClick} className='explore'>Explore More</Button>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default SubsSucess;
